import { useEffect } from "react";
import { usePreventPageLeaveStore } from "../store";

export type UsePreventPageLeaveOptions = {
  isPrevening: boolean;
};

const usePreventPageLeave = ({ isPrevening }: UsePreventPageLeaveOptions) => {
  const setPreventing = usePreventPageLeaveStore((state) => state.setPreventing);

  useEffect(() => {
    setPreventing(isPrevening);
  }, [isPrevening, setPreventing]);
};

export default usePreventPageLeave;
